// Campos do laudo de calibracao de TERMOMETRO.
// Para mudar esse formulario, mexa so neste arquivo.
const termometro = {
  titulo: 'Termômetro / Termorresistência',
  leituras: 'carga',
  secoes: [
    {
      titulo: 'Identificação do instrumento',
      campos: [
        { n: 'subtipo', l: 'Equipamento', t: 'sel', span: 5, ajuda: 'Define o nome que sai no título e no bloco do laudo. Os dois usam o mesmo formulário.',
          o: [['termometro', 'Termômetro'], ['termorresistencia', 'Termorresistência']] },
        { n: 'tag', l: 'TAG', t: 'texto', span: 4, up: true, ajuda: 'Identificação do instrumento dentro do cliente. Ex.: TE-01.' },
        { n: 'marca', l: 'Marca', t: 'texto', span: 5, ajuda: 'Fabricante gravado no instrumento. Em branco sai NÃO CONSTA no laudo.' },
        { n: 'modelo', l: 'Modelo', t: 'texto', span: 5, ajuda: 'Modelo do fabricante, quando houver.' },
        { n: 'numero_serie', l: 'Nº de série', t: 'texto', span: 5, ajuda: 'Número de série do instrumento, quando houver.' },
        { n: 'tipo_instrumento', l: 'Tipo', t: 'sel', span: 5, ajuda: 'Como o termômetro mede e indica. É o campo Tipo do laudo.',
          o: [['digital', 'Digital'], ['analogico', 'Analógico'], ['infravermelho', 'Infravermelho'], ['bimetalico', 'Bimetálico'], ['espeto', 'Espeto']] },
        { n: 'classe', l: 'Classe', t: 'texto', span: 4, ajuda: 'Classe de exatidão informada pelo fabricante. Sem essa informação na placa, deixe vazio.' },
        { n: 'local_instalacao', l: 'Local de instalação', t: 'texto', span: 6, ajuda: 'Onde o termômetro fica instalado. Se a calibração veio de um laudo de inspeção, costuma ser a TAG do equipamento.' },
        { n: 'unidade', l: 'Unidade', t: 'sel', span: 4, fixo: true, o: [['°C', '°C']], ajuda: 'Termômetro é sempre registrado em °C.' },
        { n: 'validade_anos', l: 'Validade', t: 'sel', span: 3, ajuda: 'De quanto em quanto tempo o termômetro deve ser recalibrado.',
          o: [[1, '1 ano'], [2, '2 anos'], [3, '3 anos'], [4, '4 anos'], [5, '5 anos']] },
        { n: 'data_calibracao', l: 'Data', t: 'data', span: 3, ajuda: 'Data em que a calibração foi executada.' }
      ]
    },
    {
      titulo: 'Faixa e condições',
      campos: [
        { n: 'temp_min', l: 'Temp. mínima (°C)', t: 'num', span: 4, ajuda: 'Menor temperatura que o termômetro mede. Aceita número negativo.' },
        { n: 'temp_max', l: 'Temp. máxima (°C)', t: 'num', span: 4, ajuda: 'Maior temperatura que o termômetro mede.' },
        { n: '_amplitude', l: 'Amplitude', t: 'calc', span: 4, ajuda: 'Máxima menos mínima. Calculada sozinha, não é digitada.',
          calc: (v) => (v.temp_min != null && v.temp_max != null) ? String(Number(v.temp_max) - Number(v.temp_min)).replace('.', ',') + ' °C' : '' },
        { n: 'resolucao', l: 'Resolução (°C)', t: 'num', span: 4, ajuda: 'Menor divisão que o display mostra. Ex.: 0,1 para um termômetro que vai de 0,1 em 0,1.' },
        { n: 'temp_ambiente', l: 'Temperatura ambiente', t: 'texto', span: 4, ajuda: 'Temperatura do ambiente durante a calibração, com a tolerância. Vai assim mesmo para o laudo.' },
        { n: 'umidade', l: 'Umidade do ar', t: 'texto', span: 4, ajuda: 'Umidade do ambiente durante a calibração, com a tolerância.' }
      ]
    }
  ],
  pontos: {
    ajuda: 'V.M é a temperatura indicada pelo padrão no ponto. VVC é o que o termômetro mostrou, no aquecimento (carregamento) e no resfriamento (descarregamento).',
    colunas: [
      { n: 'vm', l: 'V.M — valor do padrão', ajuda: 'Temperatura de referência do ponto, lida no padrão.' },
      { n: 'carga', l: 'VVC carregamento', ajuda: 'Leitura do termômetro com a temperatura subindo.' },
      { n: 'desc', l: 'VVC descarregamento', ajuda: 'Leitura do termômetro com a temperatura descendo.' }
    ]
  },
  fechamento: [
    { n: 'fator_k', l: 'Fator k', t: 'sel', span: 4, o: [[2, '2 (95%)'], [3, '3 (99%)']],
      ajuda: 'Multiplicador da incerteza padrão para chegar na incerteza expandida. k = 2 corresponde a cerca de 95% de confiança.' },
    { n: 'danificado', l: 'Danificado?', t: 'bool', span: 4, ajuda: 'Marque se o termômetro chegou com dano que impeça o uso.' },
    { n: 'substituido', l: 'Substituído?', t: 'bool', span: 4, ajuda: 'Marque se o termômetro foi trocado por outro no atendimento.' }
  ]
};

export default termometro;
